import { DestructiveDialogResult, makeDialog } from '@cast/design-system';

import {
  DisconnectSlackWorkspaceDialogContent,
  DisconnectSlackWorkspaceDialogProps,
} from './DisconnectSlackWorkspaceDialog';

export const useDisconnectSlackWorkspaceDialog = makeDialog<
  DisconnectSlackWorkspaceDialogProps,
  DestructiveDialogResult
>(DisconnectSlackWorkspaceDialogContent);
